import React from 'react';

import { Storage as DatabaseIcon } from '@mui/icons-material';
import { Box, Typography, Paper } from '@mui/material';

import MessageWrapper from 'pages/Analysis/components/MessageWrapper';
import type { ExecuteQueryToolArguments } from 'services/types/ticket';

interface Props {
  args: string;
}

const ExecuteQueryToolComponent: React.FC<Props> = ({ args }) => {
  let parsedArgs: ExecuteQueryToolArguments;

  try {
    parsedArgs = JSON.parse(args) as ExecuteQueryToolArguments;
  } catch (error) {
    return (
      <MessageWrapper caption="Herramienta de Base de Datos" align="left">
        <Typography color="error">Error al parsear argumentos: {args}</Typography>
      </MessageWrapper>
    );
  }

  return (
    <MessageWrapper caption="Ejecutar consulta SQL" align="left">
      <Box>
        <Box mb={2}>
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
              <DatabaseIcon sx={{ fontSize: 16, mr: 1, verticalAlign: 'text-bottom' }} />
              Consulta a PostgreSQL:
            </Typography>
          </Box>
          <Paper
            variant="outlined"
            sx={{
              p: 2,
              bgcolor: 'grey.50',
              maxHeight: '200px',
              overflow: 'auto',
              fontFamily: 'monospace',
              fontSize: '0.875rem',
              whiteSpace: 'pre-wrap',
              lineHeight: 1.4,
            }}
          >
            {parsedArgs.sqlQuery}
          </Paper>
        </Box>
      </Box>
    </MessageWrapper>
  );
};

export default ExecuteQueryToolComponent;
